export function pathToPascalCase(path) {
    return path
        .split("/")
        .filter(Boolean) // remove empty strings from consecutive '/'
        .map((segment) => segment.charAt(0).toUpperCase() + segment.slice(1))
        .join("");
}
//# sourceMappingURL=helpers.js.map